import moment from "moment";

export const dateTimeFormat = (date, isDateOnly=false) => {
    const formatedDate = moment.utc(date).local().format(isDateOnly ? 'MM/DD/YYYY' : 'MM/DD/YYYY HH:mm');
    return formatedDate;
};
